<div class="modal-header">
  <h4 class="modal-title" id="exampleModalLongTitle">Periodos</h4>
  <button type="button" class="close btn-default btn-circle" aria-label="Close" (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container" *ngIf="cr && current">

    <ul class="list-group">
      <li *ngFor="let val of cr.values" class="list-group-item" [ngClass]="{'active': val.scheduleDateID === current.scheduleDateID}">{{val.scheduleStart | date: 'longDate' : 'UTC'}} - {{val.scheduleEnd | date: 'longDate' : 'UTC'}} </li>
    </ul>

  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary w-100 me-2" (click)="this.activeModal.close(true)">Terminar</button>
</div>


